import { Component, Directive, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'rui-field',
    template: `
        @if (label === undefined) {
          <ng-content select="rui-field-label"></ng-content>
        } @else {
          <rui-field-label>{{ label }}</rui-field-label>
        }
        
        @if (loading) {
          <rui-field-value>
            <ngx-skeleton-loader [theme]="{ 'vertical-align': 'middle', 'margin-bottom': 0 }"></ngx-skeleton-loader>
          </rui-field-value>
        }
        @if (!loading) {
          @if (value === undefined) {
            <ng-content select="rui-field-value"></ng-content>
          } @else {
            <rui-field-value [class.italic]="value === null">{{ getValue() }}</rui-field-value>
          }
        }
        `,
    standalone: false
})
export class RuiFieldComponent {
    @HostBinding('class') classes = 'mb-5 block';
    @Input() label: string;
    @Input() value: string | number | Date;
    @Input() noValue = '---';
    @Input() loading = false;

    getValue() {
        if (typeof this.value == 'string') {
            return this.value || this.noValue;
        } else {
            return this.value ?? this.noValue;
        }
    }
}

/**
 *  Label for field
 */
@Directive({
    selector: `rui-field-label`,
    standalone: false
})
export class RuiFieldLabelComponent {
    @HostBinding('class') classes = 'text-sm text-gray-500 flex items-center';
}

/**
 *  Value for field
 */
@Directive({
    selector: `rui-field-value`,
    standalone: false
})
export class RuiFieldValueComponent {
    @HostBinding('class') classes = 'pb-1.5 pt-px block whitespace-pre-wrap';
}
